import { TmcContextService } from './../../../../../../../common/tmc-context.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TransportOption } from '../../../../../../../client/model/transport-option';

import { TranslationService } from '@sdbn/common';
import { FilterAdministrationContext } from '../../../../filter-administration.context';
import { FilterDetailsComponent } from '../../../../filter-details-component.model';
import { FilterCondition } from '../../../../filter-administration.model';

@Component({
  selector: 'app-transport-option-condition-editor',
  templateUrl: './transport-option-condition-editor.component.html',
  styleUrls: ['./transport-option-condition-editor.component.scss']
})
export class TransportOptionConditionEditorComponent implements OnInit, OnDestroy, FilterDetailsComponent {

  tmcContextSubscription: Subscription;

  transportOptions: TransportOption[] = [];

  condition: FilterCondition;

  filterAdministrationContext: FilterAdministrationContext;
  filterAdministrationContextSubscription: Subscription;

  detailsFormGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private tmcContextService: TmcContextService
  ) {

    this.tmcContextSubscription = this.tmcContextService.updated.subscribe(next => {
      if (next != null) {
        for (const to of this.tmcContextService.getYardConfiguration().transportOptions) {
          this.transportOptions.push(to);
        }
      }
    });

    this.detailsFormGroup.addControl('transportOptionExternalKey', new FormControl('', []));
    this.detailsFormGroup.valueChanges.subscribe(
      value => {
        if (this.detailsFormGroup.dirty) {
          this.condition.data.transportOptionExternalKey = this.detailsFormGroup.controls.transportOptionExternalKey.value;
          this.filterAdministrationContext.getFilter().dirty = true;
        }
      }
    );

  }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filterAdministrationContextSubscription != null) {
      this.filterAdministrationContextSubscription.unsubscribe();
    }
  }

  setFilterAdministrationContext(filterAdministrationContext: FilterAdministrationContext) {
    this.filterAdministrationContext = filterAdministrationContext;
    this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
    this.resetForm();
    this.filterAdministrationContextSubscription = this.filterAdministrationContext.contextChange$.subscribe(
      change => {
        try {
          if (change.key === 'selected-filter-condition-changed') {
            this.condition = this.filterAdministrationContext.getSelectedFilterCondition();
            this.resetForm();
          }
        } catch (error) {
          console.log(error);
        }
      }
    );
  }

  private resetForm() {
    this.detailsFormGroup.reset(this.condition.data);
  }
}
